import PropTypes from 'prop-types';
import BatchSchedule from '@cont/Batch/BatchSchedule';
import { fetchBatchData } from '@actions/batches';
import SEO from '@seo/index';
import batchSubTopicsSchema from '@seo/batch/batchSubTopics';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { BATCH_CONTENT_TYPE_MAP, getIsStoreSyllabus } from '@cont/Batch/utils';
import RecordedBatchSchedule from '@cont/Batch/RecordedBatch/RecordedBatchSchedule';

const Schedule = ({ batchUID, batchData }) => {
  const {
    thumbnail,
    permalink,
    description,
    goal,
    name,
    contentType,
    additionalFeatures
  } = batchData || {};

  const isStoreSyllabus = getIsStoreSyllabus({ additionalFeatures });
  const metaTitle = `Schedule for ${name} by Unacademy`;
  const canonicalURL = `${permalink}/schedule`;
  const metaDescription = description;
  return (
    <>
      <SEO
        title={metaTitle}
        url={canonicalURL}
        description={metaDescription}
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          images: [
            {
              url: thumbnail
            }
          ],
          url: canonicalURL
        }}
        schema={batchSubTopicsSchema({
          goal,
          others: [
            {
              name,
              url: `${permalink}`
            },
            {
              name: 'Schedule',
              url: `${permalink}/schedule`
            }
          ]
        })}
      />

      {(contentType === BATCH_CONTENT_TYPE_MAP.LIVE_RECORDED ||
        contentType === BATCH_CONTENT_TYPE_MAP.RECORDED) &&
      !isStoreSyllabus ? (
        <RecordedBatchSchedule
          batchUID={batchUID}
          batchGoalUID={goal?.topology}
        />
      ) : (
        <BatchSchedule batchUID={batchUID} />
      )}
    </>
  );
};

Schedule.pageInfo = {
  name: 'Batch Schedule Details',
  isMWebSupported: true,

  layoutOptions: {
    hideFooter: true
  }
};

Schedule.getInitialProps = setupInitialProps(async ({ store, query }) => {
  const { associated_batch } = query;
  // associated_batch is the batchUID ,this comes from platform
  const batchUID = associated_batch || query.batchUID;
  let batchData = store.getState().batches.data[batchUID];
  if (!batchData) {
    await store.dispatch(fetchBatchData(batchUID));
    batchData = store.getState().batches.data[batchUID];
  }
  return { batchUID, batchData };
}, Schedule.pageInfo);

export default Schedule;

Schedule.propTypes = {
  batchUID: PropTypes.string.isRequired,
  batchData: PropTypes.objectOf(PropTypes.any).isRequired
};
Schedule.Layout = Layout;
Schedule.Wrapper = PageReduxProvider;
